import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../_metronic/layout";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider, } from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "./_redux/Actions";
import { Pagination } from "../../../_metronic/_partials/controls";
import * as columnFormatters from "../../components/column-formatters";
import * as UIHelpers from "../../components/UIHelpers";
import DeleteDialog from "../../components/DeleteDialog";
import FilterComponent from "../../components/FilterComponent";
import {
    // getSelectRow,
    // getHandlerTableChange,
    NoRecordsFoundMessage,
    PleaseWaitMessage,
    sortCaret,
    headerSortingClasses,
} from "../../../_metronic/_helpers";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import helperFunc from "../../../_metronic/_helpers/helperFunc";

export const initialFilter = {
    filter: {},
    q: '',
    sort: "asc", // asc||desc
    sortBy: "name",
    skip: UIHelpers.skip,
    limit: UIHelpers.limit,
    page: UIHelpers.page,
};

const ListComponent = (props) => {
    const dispatch = useDispatch();
    const suhbeader = useSubheader();
    const [filter, setFilter] = useState(initialFilter);
    const [count, setCount] = useState(0);
    const [cpage, setCpage] = useState(1);

    const [isDeleteShow, setIsDeleteShow] = useState(false);
    const [deleteItemRow, setDeleteItemRow] = useState(undefined);
    suhbeader.setTitle("Currencies");
    // suhbeader.setIsSearch(true);
    useEffect(() => {
        filter.q = suhbeader.searchText.q
        setFilter(filter);
        setCount(count + 1);
    }, [suhbeader, suhbeader.searchText]);

    const newItem = () => {
        props.history.push("/currencies/create");
    }
    const editItem = (id) => {
        props.history.push(`/currencies/edit/${id}`);
    }

    const deleteItem = () => {
        setCpage(1)
        const id = deleteItemRow && deleteItemRow._id;
        dispatch(actions.deleteItem(id)).then(() => {
            dispatch(actions.fetchList(filter));
            hideDeleteConfirm();
        })

    }
    const hideDeleteConfirm = () => {
        setIsDeleteShow(false);
        setDeleteItemRow(undefined);
    }
    const deleteItemConfirm = (row) => {
        setIsDeleteShow(true);
        setDeleteItemRow(row);
    }
    const getHandlerTableChange = (type, data) => {
        let temp = { ...filter };
        if (type === "pagination") {
          temp.limit = data.sizePerPage;
          temp.skip = data.page > 1 ? data.sizePerPage * (data.page - 1) : 0;
          temp.page = data.page || 1;
      
          setFilter(temp);
          if(!listLoading)
            dispatch(actions.fetchList(temp));
        }
      };
      
    const filterChange = (filterData) => {
        filter.q = filterData.q;
        filter.filter = filterData.filter;
        setFilter(filter);
        if(!listLoading)
            dispatch(actions.fetchList(filter));
    }
    const statusChange = (data) => {
        let params =  {};
        params.isActive = !data.isActive;
        params._id = data._id;
        dispatch(actions.updateItemsStatus(params, params._id)).then((sucess) => sucess ? dispatch(actions.fetchList(filter)) : null);
    }
    const columns = [
        {
            dataField: "name",
            text: "Name",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "code",
            text: "Code",
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "symbol",
            text: "Symbol",
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "img",
            text: "Image",
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.ImageColumnFormatter,
            formatExtraData: {
                dIndexName: 'img'
            },
        },
        {
            dataField: "createdAt",
            text: "CreatedAt",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.DateColumnFormatter,
        },
        {
            dataField: "isActive",
            text: "IsActive",
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.StatusColumnFormatter,
            formatExtraData: {
                statusChange: helperFunc.isButtonAccess('master.currency.update') ? statusChange : null,
            },
        },
        {
            dataField: "action",
            text: "Actions",
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                editItem: helperFunc.isButtonAccess('master.currency.add') ? editItem : null,
                deleteItem: helperFunc.isButtonAccess('master.currency.delete') ? deleteItemConfirm : null,
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
        },
    ];
    const { currentState } = useSelector(
        (state) => ({ currentState: state.currency }),
        shallowEqual
    );
    const { totalCount, entities, listLoading } = currentState;

    useEffect(() => {
        let pdata = {}
        pdata.pagination = {}
        pdata.pagination.pageNo = filter.page
        pdata.pagination.recordPerPage = filter.limit
        pdata.skip = filter.skip
      
        dispatch(actions.fetchList(pdata));
      }, []);
      

    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: totalCount,
        sizePerPageList: UIHelpers.sizePerPageList,
        sizePerPage: filter.limit,
        page: filter.page,
    };
    return (
        <>
            <DeleteDialog
                show={isDeleteShow}
                name={deleteItemRow && deleteItemRow.name}
                item={deleteItemRow}
                onDelete={deleteItem}
                onHide={hideDeleteConfirm}
            />
            <Card>
                <CardHeader title="Currencies list">
                    <CardHeaderToolbar>
                        {helperFunc.isButtonAccess('master.currency.add') && (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={newItem}
                            >New Currency</button>
                        )}
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    <FilterComponent filterChange={filterChange} />
                    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                        {({ paginationProps, paginationTableProps }) => {
                            return (
                                <Pagination
                                    isLoading={listLoading}
                                    paginationProps={paginationProps}
                                >
                                    <BootstrapTable
                                        wrapperClasses="table-responsive"
                                        bordered={false}
                                        classes="table table-head-custom table-vertical-center overflow-hidden"
                                        bootstrap4
                                        remote
                                        keyField="_id"
                                        data={entities ? entities : []}
                                        columns={columns}
                                        onTableChange={getHandlerTableChange}
                                        {...props}
                                        {...paginationTableProps}
                                    >
                                        <PleaseWaitMessage entities={entities} />
                                        <NoRecordsFoundMessage entities={entities} />
                                    </BootstrapTable>
                                </Pagination>
                            );
                        }}
                    </PaginationProvider>
                </CardBody>
            </Card>
        </>
    )
}
export default ListComponent;